import React from "react";

import { AutoSizer, Grid } from "react-virtualized";

import TableLoader, {
  Table,
  TableBody,
  TableColumn,
  TableRow,
  TableHeaderRow,
  TableHeaderColumn
} from "components/Table/Table.js";
import SearchInput from "components/Inputs/SearchInput/SearchInput";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import styles from "./style.module.css";

export default class NextSubView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0, fixMe: false, gridWidth: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
    const width = this.divElement.clientWidth;
    this.setState({ gridWidth: width });
  }

  renderShowMore(style) {
    const { fetchNext, fetchAll, isLoading, length, hideShowMore } = this.props;

    if (hideShowMore) {
      return <React.Fragment></React.Fragment>;
    }

    return (
      <div style={style} key={"showMore"}>
        {!isLoading && fetchNext && (
          <div className={styles.showHolder}>
            <a className={styles.showMore} onClick={() => fetchNext()}>
              {"Show More"}
            </a>
            {fetchAll && (
              <a className={styles.showMore} style={{ marginLeft: "20px" }} onClick={() => fetchAll()}>
                {"Show All"}
              </a>
            )}
          </div>
        )}
        {isLoading && (
          <div className={styles.lHolder}>
            <LoadingIndicator />
          </div>
        )}
      </div>
    );
  }

  renderTiles() {
    const {
      children,
      firstTile,
      fetchNext,
      fetchAll,
      isLoading,
      type,
      firstWidth,
      isInfinite,
      renderTile,
      childrenLength,
      height,
      width,
      length,
      tileHeight,
      hideShowMore,
      isModal,
      isMini,
      emptyMessage
    } = this.props;
    const tileDimensions = {
      wrapperWidth: 240,
      wrapperHeight: 250
    };
    let gridColWidth = tileDimensions.wrapperWidth;
    let gridHeight = tileDimensions.wrapperHeight + 15;
    let gridRowHeight = tileDimensions.wrapperHeight;

    if (this.state.width < 800) {
      gridColWidth = 140;
      gridHeight = 145;
      gridRowHeight = 130;
    }
    if (tileHeight) {
      gridHeight = tileHeight + 20;
      gridRowHeight = tileHeight;
    }
    if (height) {
      gridHeight = height + 20;
      gridRowHeight = height;
    }
    if (width) {
      gridColWidth = width;
    }
    const firstTileChildren =
      firstTile &&
      firstTile.props &&
      firstTile.props.children &&
      firstTile.props.children.length > 1 &&
      firstTile.props.children.filter((e) => Boolean(e));
    const firstTileLength = firstTileChildren ? firstTileChildren.length : 0;
    const numDisplayCols = this.state?.gridWidth > 0 ? Math.max(Math.floor(this.state.gridWidth / 230), 2) : 2;
    const cellRenderer = (columnIndex, rowIndex, style) => {
      const fakeColumnIndex = columnIndex + rowIndex * numDisplayCols;
      if (isMini) {
        return fakeColumnIndex < firstTileLength ? (
          columnIndex === 0 && rowIndex === 0 ? (
            <div className={styles.firstTileHolder} key={"firstTile"}>
              {firstTile}
            </div>
          ) : (
            <React.Fragment />
          )
        ) : fakeColumnIndex - firstTileLength >= childrenLength ? (
          fakeColumnIndex - firstTileLength > childrenLength ? (
            <React.Fragment />
          ) : (
            this.renderShowMore(style)
          )
        ) : (
          renderTile(fakeColumnIndex - firstTileLength, style)
        );
      } else {
        return columnIndex >= childrenLength ? this.renderShowMore(style) : renderTile(columnIndex, style);
      }
    };
    return type === "all" || isMini ? (
      <div className={styles.listHolder} style={{ marginTop: "5px", paddingLeft: "0px" }}>
        <div className={styles.flexHold}>
          {isMini !== true && (
            <div
              className={styles.fList}
              style={
                firstWidth
                  ? {
                      width: firstWidth,
                      minWidth: firstWidth
                    }
                  : {}
              }
            >
              {firstTile}
            </div>
          )}
          <div className={styles.list} style={isInfinite ? { overflow: "visible" } : {}}>
            {!isLoading && length === 0 && !firstTileLength && (
              <div
                className={styles.lHolder}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "10px"
                }}
              >
                {"No results found"}
                {this.renderShowMore()}
              </div>
            )}
            {(length !== 0 || firstTileLength || isLoading) && isInfinite && (
              <AutoSizer>
                {({ height, width }) => (
                  <Grid
                    cellRenderer={({ columnIndex, rowIndex, style }) => cellRenderer(columnIndex, rowIndex, style)}
                    rowCount={Math.round((childrenLength + 1 + (isMini ? firstTileLength : 0)) / 2)}
                    columnWidth={gridColWidth}
                    height={gridHeight * 2.2}
                    columnCount={numDisplayCols}
                    rowHeight={gridRowHeight}
                    overscanColumnCount={5}
                    width={this.state.gridWidth}
                    style={{ outline: "none" }}
                    key={this.state.width}
                    id={"blueprintPickerGrid"}
                  />
                )}
              </AutoSizer>
            )}
            {!isInfinite && children}
            {!isInfinite && this.renderShowMore()}
          </div>
        </div>
      </div>
    ) : (
      <div className={styles.tileHolder} style={height ? { height: height, overflow: "auto" } : {}}>
        <div className={styles.tileH + (isModal ? " " + styles.modal : "")}>
          {firstTile}
          {!isLoading && length === 0 ? (
            emptyMessage ? (
              emptyMessage
            ) : (
              <div>
                <div
                  className={styles.lHolder}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "10px"
                  }}
                >
                  {"No results found"}
                </div>
              </div>
            )
          ) : (
            ""
          )}
          {isInfinite &&
            childrenLength > 0 &&
            Array(childrenLength)
              .fill()
              .map((_, i) => renderTile(i))}
        </div>
        {isLoading && (
          <div className={styles.lHolder}>
            <LoadingIndicator style={{ marginTop: "-60px" }} />
          </div>
        )}
        {!isLoading && fetchNext && !hideShowMore && (
          <div className={styles.showHolder} style={{ height: "20px", marginTop: "20px" }}>
            <a className={styles.showMore} onClick={() => fetchNext()}>
              {"Show More"}
            </a>
          </div>
        )}
      </div>
    );
  }

  renderTable() {
    const { label, headers, children, firstRow, fetchNext, isLoading, renderTile, childrenLength, length, type } =
      this.props;
    return (
      <div>
        <div className={styles.typeHeader}>
          {label}
          <div className={styles.tableActions}>
            {firstRow}
            {length > 0 && !isLoading && (
              <div className={styles.showMore} style={{ marginLeft: "20px", textAlign: "center" }}>
                <a onClick={() => fetchNext(type)}>{"Show More"}</a>
              </div>
            )}
            {isLoading && <LoadingIndicator style={{ margin: "0px", position: "absolute", right: "-80px" }} />}
          </div>
        </div>
        <div className={styles.homeTableHolder} style={{ maxHeight: type === "all" ? "25vh" : "calc(100vh - 404px)" }}>
          {headers && length > 0 && (
            <Table className="table">
              <TableHeaderRow>
                {headers.map((h, i) => (
                  <TableHeaderColumn key={i}>{h}</TableHeaderColumn>
                ))}
              </TableHeaderRow>
              <TableBody>
                {Array(childrenLength)
                  .fill()
                  .map((_, i) => renderTile(i))}
              </TableBody>
            </Table>
          )}
          {!isLoading && length === 0 && <div className={styles.emptyJobs}>{"No results found"}</div>}
        </div>
      </div>
    );
  }

  render() {
    const { isTile, height } = this.props;

    return (
      <div
        className={styles.subView}
        ref={(divElement) => {
          this.divElement = divElement;
        }}
      >
        {isTile ? this.renderTiles() : this.renderTable()}
      </div>
    );
  }
}
